import i from"@emotion/styled";import{retrieveButtonSize as t,retrieveButtonVariant as n}from"./button.utils.js";const o=i.button`
  label: button;
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  border-style: solid;
  position: relative;
  outline-width: 0px;
  border-width: 0px;
  padding-left: 16px;
  padding-right: 16px;
  font-weight: 500;
  transition-property: color, background-color, border-color,
    text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  column-gap: 8px;
  &:pointer-events-none:disabled {
    pointer-events: none;
  }
  ${e=>t(e.size)};
  ${e=>e.isCornerMax?{borderRadius:"9999px"}:{borderRadius:"6px"}};
  ${e=>e.isFullWidth&&{width:"100%"}}
  ${e=>e.shouldCompact&&{height:"auto",paddingRight:0,paddingLeft:0}};
  ${e=>(e.isLoading||e.disabled)&&{pointerEvents:"none"}};
  ${e=>n(e.variant,e.color,e.disabled)}
`,r=i.span`
  label: button-adornment-wrapper;
  display: flex;
  ${e=>e.isLoading&&{visibility:"hidden"}};
`,a=i.span`
  label: button-children-wrapper;
  display: flex;
  ${e=>e.isLoading&&{visibility:"hidden"}};
`,d=i.div`
  label: button-loader-wrapper;
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`;export{r as AdornmentWrapperStyled,o as ButtonStyled,a as ChildrenWrapperStyled,d as LoaderWrapperStyled};
